window.$ = jQuery;
window.HALLANDHALL = {

    // All pages
    global: {
        player: null,
        init: function () {
            this.videoStartTrigger();
            this.initBackgroundVideo();
            this.propertyListItem();
            this.favoriteProperties();
            this.removeSavedPropertySearch();
            this.initYTPlayer();
        },

        initGlobal: function () {

            // Bootstrap Tooltip
            $('[data-toggle="tooltip"]').tooltip({trigger: 'hover'});

            // Equal Heights
            $(".eh-row [class*='col-']").matchHeight({ property: 'min-height' }); // global equal height
            $('.carousel-item').matchHeight({ property: 'height' }); // Carousel equal height

            // Dropcap
            $('.has-dropcap p:first-child').each(function () {
                var text = $.trim(this.innerHTML),
                    firstLetter = text[0],
                    dropCap = '<span class="dropcap">' + firstLetter + '</span>';

                this.innerHTML = text.replace(firstLetter, dropCap);
            });

            // Tabs
            $('.nav-tabs-responsive').find('a').on('click', function (e) {
                console.log('here');
                console.log(e);
                e.preventDefault();
                $(this).tab('show');
            });

        },

        initYTPlayer: function () {
            var tag = document.createElement('script');

            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        },

        onPlayerStateChange: function (event) {
            let player = window.HALLANDHALL.global.player;
            if (event.data == YT.PlayerState.ENDED) {
                player.seekTo(0);
                player.stopVideo();
                $('#video-frame').closest('.video-modal').modal('hide');
                // $('#video-gallery-item-grid').modal('hide');
                // $('.video-modal').modal('hide');
            }
        },

        // Video start and stop triggers for popups
        videoStartTrigger: function () {
            $('.video-modal').on('hidden.bs.modal', function (e) {
                let iframes = $(this).find('iframe'),
                    iframe = iframes[0];

                window.HALLANDHALL.global.player.stopVideo();
            });

            $('.video-start-target').on('click', function () {
                if($(this).data('video-id') != "") window.HALLANDHALL.global.player.loadVideoById($(this).data('video-id'));
            });
        },

        // Background Video
        initBackgroundVideo: function () {
            if ($(window).width() < 769) {
                var viewportHeight = $(window).height() - $('.site-header').outerHeight();
                $('.hero-block.is-video').css('height', viewportHeight + 'px');
            }
        },

        // Property Listings
        propertyListings: function () {
            // Removed
        },

        propertyListItem: function () {
            $('.listing-favorite-not-logged-in').tooltip();

            $('.property-item').each(function () {
                var favoriteButton = $(this).find('.listing-favorite');

                favoriteButton.on('click', function () {
                    if ($(this).hasClass('user-is-logged-in')) {
                        if ($(this).hasClass('is-favorite')) {
                            $(this).attr('title', 'Add to Favorites');
                            $(this).attr('data-original-title', 'Add to Favorites');
                        } else {
                            $(this).attr('title', 'Remove from Favorites');
                            $(this).attr('data-original-title', 'Remove from Favorites');
                        }
                    }
                });
            });
        },

        propertyDetailPage: function () {
            // Removed
        },

        homePage: function () {
            // Removed
        },

        auctionsPage: function () {
            // Removed
        },

        favoriteProperties: function () {

            $('.track-property-link-click').on('click', function () {
                window.helpers.gaEvent('Property', 'clicked-through', '');
            });

            var usersFavoriteCount = $('#users-favorites-count');

            $(document).on('click', '.property-item .listing-favorite', function () {
                if ($(this).hasClass('user-is-logged-in')) {
                    var selecting = (!$(this).hasClass('is-favorite')),
                        parent = $(this).parent().parent('.property-item');
                    $(this).toggleClass('is-favorite').toggleClass('is-not-favorite');
                    parent.toggleClass('is-favorite').toggleClass('is-not-favorite');

                    var propertyId = $(this).data('property-id'),
                        userId = $('#current-user-id').val();

                    var _this = $(this);

                    if (selecting) {
                        window.helpers.gaEvent('Properties', 'favorite', propertyId);
                        window.helpers.gaEvent('Favorites', 'list-view', propertyId);
                    }

                    $.post("/wp/wp-admin/admin-ajax.php", {
                        'action': 'favorite_property',
                        'property_id': propertyId,
                        'user_id': userId,
                        'mode': (selecting) ? 'select' : 'unselect'
                    }, function (data) {
                        // If on the profile page, remove the favorite the page
                        if (_this.hasClass('is-profile-page') && selecting === false) {
                            parent.fadeOut();
                            setTimeout(function () { parent.remove(); }, 400);

                            var oldFavoriteCount = parseInt(usersFavoriteCount.html());
                            usersFavoriteCount.html(oldFavoriteCount - 1);
                        }
                    });
                }
            });

            $('#property-details-favorite-property').on('click', function () {

                var selecting = (!$(this).hasClass('is-favorite'));
                $(this).toggleClass('is-favorite');

                if (selecting) {
                    $('#property-details-favorite-property-inline').addClass('disabled').attr('disabled', 'disabled').html('Property Saved');
                    $(this).html('Saved as Favorite');
                } else {
                    $('#property-details-favorite-property-inline').removeClass('disabled').attr('disabled', '').html('Save Property');
                    $(this).html('Save Property');
                }

                var propertyId = $(this).data('property-id'),
                    userId = $('#current-user-id').val();

                window.helpers.gaEvent('Properties', 'favorite', propertyId);
                window.helpers.gaEvent('Favorites', 'detail-view', propertyId);

                $.post("/wp/wp-admin/admin-ajax.php", {
                    'action': 'favorite_property',
                    'property_id': propertyId,
                    'user_id': userId,
                    'mode': (selecting) ? 'select' : 'unselect'
                }, function (data) { });

            });

            $('.listing-favorite-not-logged-in').on('click', function () {
                var propertyId = $(this).data('property-id');
                if (!window.helpers.readCookie('user-not-logged-in-favorited-property')) {
                    window.helpers.createCookie('user-not-logged-in-favorited-property', propertyId, 1);
                }
            });

            if ($('#current-user-id').length) {
                if (window.helpers.readCookie('user-not-logged-in-favorited-property')) {
                    var propertyIdToFavorite = window.helpers.readCookie('user-not-logged-in-favorited-property'),
                        userId = $('#current-user-id').val();

                    $.post("/wp/wp-admin/admin-ajax.php", {
                        'action': 'favorite_property',
                        'property_id': propertyIdToFavorite,
                        'user_id': userId,
                        'mode': 'select'
                    }, function (data) {
                        // window.helpers.showNotification('You have favorited this property!');
                        window.helpers.eraseCookie('user-not-logged-in-favorited-property');

                        location.reload();
                    });

                }
            }

            $('#property-details-favorite-property-inline').on('click', function () {

                $(this).addClass('disabled').attr('disabled', 'disabled').html('Property Saved');
                $('#property-details-favorite-property').html('Saved as Favorite').addClass('is-favorite');

                var propertyId = $(this).data('property-id'),
                    userId = $('#current-user-id').val();

                window.helpers.gaEvent('Properties', 'favorite', propertyId);
                window.helpers.gaEvent('Favorites', 'detail-view', propertyId);

                $.post("/wp/wp-admin/admin-ajax.php", {
                    'action': 'favorite_property',
                    'property_id': propertyId,
                    'user_id': userId,
                    'mode': 'select'
                }, function (data) {
                    // window.helpers.showNotification('You have favorited this property!');
                });

            });

        },

        removeSavedPropertySearch: function () {



        },

    }

};

// TODO: TEMP
// swapImagesToUseLivePaths();

$(window).on('load', function () {

    setInterval(function () {
        // swapImagesToUseLivePaths();
    }, 1000);
});

function swapImagesToUseLivePaths() {
    if(window.location.hostname === 'hallhall.test') {
        $('img, source, video').each(function (i, e) {
            if($(e).attr('src') && $(e).attr('src').indexOf('wp-content/') !== -1 && $(e).attr('src').indexOf('hallhall.test') !== -1) {
                $(e).attr('src', $(e).attr('src').replace('.test', '.com'));
            }
            if($(e).attr('srcset') && $(e).attr('srcset').indexOf('wp-content/') !== -1 && $(e).attr('srcset').indexOf('hallhall.test') !== -1) {
                $(e).attr('srcset', $(e).attr('srcset').replaceAll('.test', '.com'));
            }
        });
    }
}

$('a').on('click', function (e) {
    if($(this).attr('href') && $(this).attr('href') === '#') {
        e.preventDefault();
    }

    if($(this).attr('href') === '#get-started') {
        $('#finance-get-started-modal').modal('show');
    }
});

Number.prototype.format = function (n, x) {
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
    return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
};

global.helpers = [];

global.helpers.mapPositioningOptions = {
    "al": { "zoom": 7, "lat": 32.7794, "long": -86.8287 },
    "ak": { "zoom": 7, "lat": 64.0685, "long": -152.2782 },
    "az": { "zoom": 7, "lat": 34.2744, "long": -111.6602 },
    "ar": { "zoom": 7, "lat": 34.8938, "long": -92.4426 },
    "ca": { "zoom": 7, "lat": 37.1841, "long": -119.4696 },
    "co": { "zoom": 7, "lat": 38.9972, "long": -105.5478 },
    "ct": { "zoom": 7, "lat": 41.6219, "long": -72.7273 },
    "de": { "zoom": 7, "lat": 38.9896, "long": -75.5050 },
    "fl": { "zoom": 7, "lat": 28.6305, "long": -82.4497 },
    "ga": { "zoom": 7, "lat": 32.6415, "long": -83.4426 },
    "hi": { "zoom": 7, "lat": 20.2927, "long": -156.3737 },
    "id": { "zoom": 7, "lat": 44.3509, "long": -114.6130 },
    "il": { "zoom": 7, "lat": 40.0417, "long": -89.1965 },
    "in": { "zoom": 7, "lat": 39.8942, "long": -86.2816 },
    "ia": { "zoom": 7, "lat": 42.0751, "long": -93.4960 },
    "ks": { "zoom": 7, "lat": 38.4937, "long": -98.3804 },
    "ky": { "zoom": 7, "lat": 37.5347, "long": -85.3021 },
    "la": { "zoom": 7, "lat": 31.0689, "long": -91.9968 },
    "me": { "zoom": 7, "lat": 45.3695, "long": -69.2428 },
    "md": { "zoom": 7, "lat": 39.0550, "long": -76.7909 },
    "ma": { "zoom": 7, "lat": 42.2596, "long": -71.8083 },
    "mi": { "zoom": 7, "lat": 44.3467, "long": -85.4102 },
    "mn": { "zoom": 7, "lat": 46.2807, "long": -94.3053 },
    "ms": { "zoom": 7, "lat": 32.7364, "long": -89.6678 },
    "mo": { "zoom": 7, "lat": 38.3566, "long": -92.4580 },
    "mt": { "zoom": 7, "lat": 47.0527, "long": -109.6333 },
    "ne": { "zoom": 7, "lat": 41.5378, "long": -99.7951 },
    "nv": { "zoom": 7, "lat": 39.3289, "long": -116.6312 },
    "nh": { "zoom": 7, "lat": 43.6805, "long": -71.5811 },
    "nj": { "zoom": 7, "lat": 40.1907, "long": -74.6728 },
    "nm": { "zoom": 7, "lat": 34.4071, "long": -106.1126 },
    "ny": { "zoom": 7, "lat": 42.9538, "long": -75.5268 },
    "nc": { "zoom": 7, "lat": 35.5557, "long": -79.3877 },
    "nd": { "zoom": 7, "lat": 47.4501, "long": -100.4659 },
    "oh": { "zoom": 7, "lat": 40.2862, "long": -82.7937 },
    "ok": { "zoom": 7, "lat": 35.5889, "long": -97.4943 },
    "or": { "zoom": 7, "lat": 43.9336, "long": -120.5583 },
    "pa": { "zoom": 7, "lat": 40.8781, "long": -77.7996 },
    "ri": { "zoom": 7, "lat": 41.6762, "long": -71.5562 },
    "sc": { "zoom": 7, "lat": 33.9169, "long": -80.8964 },
    "sd": { "zoom": 7, "lat": 44.4443, "long": -100.2263 },
    "tn": { "zoom": 7, "lat": 35.8580, "long": -86.3505 },
    "tx": { "zoom": 6, "lat": 31.4757, "long": -99.3312 },
    "ut": { "zoom": 7, "lat": 39.3055, "long": -111.6703 },
    "vt": { "zoom": 7, "lat": 44.0687, "long": -72.6658 },
    "va": { "zoom": 7, "lat": 37.5215, "long": -78.8537 },
    "wa": { "zoom": 7, "lat": 47.3826, "long": -120.4472 },
    "wv": { "zoom": 7, "lat": 38.6409, "long": -80.6227 },
    "wi": { "zoom": 7, "lat": 44.6243, "long": -89.9941 },
    "wy": { "zoom": 7, "lat": 42.9957, "long": -107.5512 }
};


global.helpers.defaultGoogleMapStyles = [
    {
        "featureType": "water",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#b5cbe4"
            }
        ]
    },
    {
        "featureType": "landscape",
        "stylers": [
            {
                "color": "#efefef"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#83a5b0"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#bdcdd3"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e3eed3"
            }
        ]
    },
    {
        "featureType": "administrative",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "lightness": 33
            }
        ]
    },
    {
        "featureType": "road"
    },
    {
        "featureType": "poi.park",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "lightness": 20
            }
        ]
    },
    {},
    {
        "featureType": "road",
        "stylers": [
            {
                "lightness": 20
            }
        ]
    }
];



function logEvent(category, action, label, value) {
    if (typeof ga === 'function' && typeof ga.getAll === 'function') {
        var command = '';

        if (typeof google_tag_manager !== 'undefined')
            command = ga.getAll()[0].get('name') + '.';

        command += 'send';

        ga(command, 'event', {
            'eventCategory': category,
            'eventAction': action,
            'eventLabel': label,
            'eventValue': typeof value === 'undefined' ? 1 : value
        });
    } else {
        console.log('ga() not defined');
    }
}


window.helpers.updateUrl = function(param, value) {
    var newUrl = "";
    if (window.helpers.getQueryVariable(param)) {
        newUrl = window.helpers.updateURLParameter(window.location.href, param, value);
    } else {
        newUrl = window.helpers.addOrReplaceParam(window.location.href, param, value);
    }

    newUrl = window.helpers.cleanUrl(newUrl);

    if (window.helpers.readCookie('current_search_string') !== null) {
        window.helpers.eraseCookie('current_search_string');
    }

    window.helpers.createCookie('current_search_string', newUrl, 1);

    if (window.history.replaceState) {
        window.history.replaceState(null, null, newUrl);
    }
}

window.helpers.removeStateFromUrl = function(url) {
    for (var key in window.states) {
        if (window.states[key].state != null) {
            url = url.replace(window.states[key].state.replace(' ', '-').toLowerCase() + '/', '', url);
        }
    }
    return url;
}

window.helpers.removeTypeFromUrl = function(url) {
    for (var key in window.propertyTypes) {
        url = url.replace(key + '/', '', url);
    }
    return url;
}

window.helpers.cleanUrl = function(url) {
    var urlBreakdown = url.split('?'),
        params = urlBreakdown[1].split('&');

    for (var i = 0; i < params.length; i++) {
        if (window.helpers.includes(params[i], '=')) {
            var paramBreakdown = params[i].split('=');

            if (paramBreakdown[1] === "") {
                url = url.replace('?' + paramBreakdown[0] + '=', '?', url);
                url = url.replace('?' + paramBreakdown[0], '?', url);

                url = url.replace('&' + paramBreakdown[0] + '=', '', url);
                url = url.replace('&' + paramBreakdown[0], '', url);
            } else if (paramBreakdown[1] === "unselected") {
                url = url.replace('?' + paramBreakdown[0] + '=unselected', '', url);
            }
        } else {
            url = url.replace('?' + params[i], '?', url);
            url = url.replace('&' + params[i], '', url);
            url = url.replace(params[i], '', url);
        }
    }

    url = url.replace('?&', '?', url);

    return url;
}

window.helpers.arrayToQueryString = function(array_in, split) {
    var out = [];
    for (var key in array_in) {
        out.push(encodeURIComponent(array_in[key]));
    }
    return out.join(split);
}



window.helpers.showNotification = function(message, type) {

    $('#notification-modal-message').html(message);
    $('#notification-modal').modal('show');

    setTimeout(function () {
        $('#notification-modal').modal('hide');
    }, 2000);

}

window.helpers.startIframe = function(iframe) {
    if (iframe.src.indexOf("?") < 0) {
        // iframe.src += "?autoplay=1&mute=1";
        iframe.src += "?autoplay=1";
    } else {
        // iframe.src += "&autoplay=1&mute=1";
        iframe.src += "&autoplay=1";
    }
}

window.helpers.stopIframe = function(iframe) {
    // var newSrc = iframe.src;
    // newSrc = newSrc.replace('&autoplay=1', '');
    // iframe.src = newSrc;
}

window.helpers.getQueryVariable = function (variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) { return pair[1]; }
    }
    return (false);
}


window.helpers.addOrReplaceParam = function (url, param, value) {
    param = encodeURIComponent(param);
    var r = "([&?]|&amp;)" + param + "\\b(?:=(?:[^&#]*))*";
    var a = document.createElement('a');
    var regex = new RegExp(r);
    var str = param + (value ? "=" + encodeURIComponent(value) : "");
    a.href = url;
    var q = a.search.replace(regex, "$1" + str);
    if (q === a.search) {
        a.search += (a.search ? "&" : "") + str;
    } else {
        a.search = q;
    }
    return a.href;
}

window.helpers.updateURLParameter = function(url, param, paramVal) {
    var TheAnchor = null;
    var newAdditionalURL = "";
    var tempArray = url.split("?");
    var baseURL = tempArray[0];
    var additionalURL = tempArray[1];
    var temp = "";

    if (additionalURL) {
        var tmpAnchor = additionalURL.split("#");
        var TheParams = tmpAnchor[0];

        TheAnchor = tmpAnchor[1];
        if (TheAnchor)
            additionalURL = TheParams;

        tempArray = additionalURL.split("&");

        for (var i = 0; i < tempArray.length; i++) {
            if (tempArray[i].split('=')[0] != param) {
                newAdditionalURL += temp + tempArray[i];
                temp = "&";
            }
        }
    }
    else {
        let tmpAnchor = baseURL.split("#"),
            TheParams = tmpAnchor[0];
        TheAnchor = tmpAnchor[1];

        if (TheParams) baseURL = TheParams;
    }

    if (TheAnchor) paramVal += "#" + TheAnchor;

    let rows_txt = temp + "" + param + "=" + encodeURIComponent(paramVal);
    return baseURL + "?" + newAdditionalURL + rows_txt;
}

window.helpers.createOrUpdateCookie = function (name, value, days) {
    if (window.helpers.readCookie(name)) window.helpers.eraseCookie(name);
    window.helpers.createCookie(name, value, days);
}

// Create cookie
window.helpers.createCookie = function(name, value, days) {
    let expires;
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}

// Read cookie
window.helpers.readCookie = function (name) {
    let nameEQ = name + "=",
        ca = document.cookie.split(';');

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') { c = c.substring(1, c.length); }
        if (c.indexOf(nameEQ) === 0) { return c.substring(nameEQ.length, c.length); }
    }

    return null;
}

// Erase cookie
window.helpers.eraseCookie = function(name) {
    window.helpers.createCookie(name, "", -1);
}

// Check if a string includes a provided value
window.helpers.includes = function(container, value) {
    return (container.indexOf(value) >= 0);
}

// Smooth scroll to given element
window.helpers.smoothScroll = function(element, offset) {
    $('html, body').animate({ scrollTop: (element[0].offsetTop - offset) }, ($(window).width() >= 768) ? 500 : 0);
}

// Number formatting
window.helpers.nFormatter = function(num, digits) {
    let si = [{ value: 1, symbol: "" }, { value: 1E3, symbol: "k" }, { value: 1E6, symbol: "M" }, { value: 1E9, symbol: "G" }, { value: 1E12, symbol: "T" }, { value: 1E15, symbol: "P" }, { value: 1E18, symbol: "E" }],
        rx = /\.0+$|(\.[0-9]*[1-9])0+$/,
        i;

    for (i = si.length - 1; i > 0; i--) { if (num >= si[i].value) break; }

    return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
}

// Detect Collision between two divs
window.helpers.collision = function($div1, $div2) {
    let x1 = $div1.offset().left, w1 = 40, r1 = x1 + w1, x2 = $div2.offset().left, w2 = 40, r2 = x2 + w2;
    return (!(r1 < x2 || x1 > r2));
}

// Google Analytic Event Trigger
window.helpers.gaEvent = function(category, action, label) {

    if (typeof ga === 'function' && typeof ga.getAll === 'function') {
        let tracker = ga.getAll()[0];
        if (tracker) tracker.send('event', category, action, label.toString());
    }
    // ga4 event
    if ( typeof gtag !== 'undefined' ) {
        // gtag( 'event', action, {
        //     'event_category': category,
        //     'event_label': label
        // } );
        gtag('event', action, {
            'event_category': category,
            'event_action': action,
            'event_label': label
        });
    }
}


UTIL = {

    fire: function (func, funcname, args) {

        var namespace = HALLANDHALL;

        funcname = (funcname === undefined) ? 'init' : funcname;
        if (func !== '' && namespace[func] && typeof namespace[func][funcname] == 'function') {
            namespace[func][funcname](args);
        }

    },

    loadEvents: function ($) {

        var bodyId = document.body.id;

        // hit up common first.
        UTIL.fire('global');

        // do all the classes too.
        $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
            UTIL.fire(classnm);
            UTIL.fire(classnm, bodyId);
        });

    }
};

// kick it all off here
jQuery(document).ready(UTIL.loadEvents);

//Call back for the youtube iframe api needs to be available and unscoped.  everything else for this is in our global scope
window.onYouTubeIframeAPIReady = function() {
    window.HALLANDHALL.global.player = new YT.Player('video-frame', {
        events: {
            'onReady': window.HALLANDHALL.global.onPlayerReady,
            'onStateChange': window.HALLANDHALL.global.onPlayerStateChange
        }
    });
}
